export default __webpack_public_path__ + "static/media/partner3.5d63df35.png";